module.exports = __webpack_public_path__ + "static/chat-avatar.61f36596.png";